import type { LeaderboardRankingRow } from '../../../domain/leaderboard/models/public-leaderboard.model';
import {
  computeLeaderboardRowProgress,
  type LeaderboardProgressContext,
} from '../../../domain/leaderboard/utils/compute-leaderboard-progress-percent';
import type { PublicParticipantApiData } from '../dtos/leaderboard-public-api.dto';

export function mapParticipantApiToSelfRow(
  data: PublicParticipantApiData | undefined,
  progressCtx: LeaderboardProgressContext,
): LeaderboardRankingRow | null {
  if (!data || !data.is_active || data.rank < 1) {
    return null;
  }
  const label = String(data.display_name ?? '').trim() || 'Tú';
  return {
    rank: data.rank,
    anonymousId: label,
    xp: data.xp ?? 0,
    progressPercent: computeLeaderboardRowProgress(data.xp ?? 0, progressCtx),
    isWinner: Boolean(data.is_winner),
    isSelf: true,
  };
}
